import type { ComponentPropsWithoutRef } from "react";
import classNames from "classnames";

export interface TabViewDisplayProps extends ComponentPropsWithoutRef<"div"> {
  children: React.ReactNode;
  className?: string;
  currentTab: string;
  tab: string;
}

export const TabViewDisplay = ({
  children,
  className,
  currentTab,
  tab,
  ...rest
}: TabViewDisplayProps) => (
  <div
    className={classNames(
      "h-full w-full overflow-y-auto",
      {
        hidden: currentTab !== tab,
      },
      className,
    )}
    aria-hidden={currentTab !== tab}
    {...rest}
  >
    {children}
  </div>
);
